import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	remove_button_label: {
		id: 'search_dialog.results.remove_button_label',
		defaultMessage: 'Remove this.',
		description: 'Label of the button that has remove function and appearance.',
	},
});
